import { Wallet, ArrowDown, ArrowUp } from '@phosphor-icons/react';

export const DistributorSummaryCards = ({ dashboard, formatCurrency }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
    <div className="bg-white border border-gray-200 p-4 sm:p-5 rounded-lg" data-testid="wallet-balance-card">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 sm:w-10 sm:h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
          <Wallet size={20} className="text-emerald-600" />
        </div>
        <span className="text-xs sm:text-sm text-gray-500">Wallet Balance</span>
      </div>
      <p className={`text-xl sm:text-2xl font-bold ${(dashboard?.total_balance || 0) >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
        {formatCurrency(dashboard?.total_balance)}
      </p>
    </div>
    <div className="bg-white border border-gray-200 p-4 sm:p-5 rounded-lg" data-testid="total-debit-card">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 sm:w-10 sm:h-10 bg-red-100 rounded-lg flex items-center justify-center">
          <ArrowDown size={20} className="text-red-600" />
        </div>
        <span className="text-xs sm:text-sm text-gray-500">Total Debit</span>
      </div>
      <p className="text-xl sm:text-2xl font-bold text-red-600">{formatCurrency(dashboard?.total_debit)}</p>
    </div>
    <div className="bg-white border border-gray-200 p-4 sm:p-5 rounded-lg" data-testid="total-credit-card">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 sm:w-10 sm:h-10 bg-green-100 rounded-lg flex items-center justify-center">
          <ArrowUp size={20} className="text-green-600" />
        </div>
        <span className="text-xs sm:text-sm text-gray-500">Total Credit</span>
      </div>
      <p className="text-xl sm:text-2xl font-bold text-green-600">{formatCurrency(dashboard?.total_credit)}</p>
    </div>
  </div>
);
